// src/components/VideoPanel.js
// import sampleVideo from '../simulation_interface/sample-drone-footage.mp4';
import './VideoPanel.css';
import { useEffect, useRef } from 'react';

export default function VideoPanel({ stream, status, isPreview }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current) return;
    videoRef.current.srcObject = stream || null;
  }, [stream]);

  return (
    <div className={`video-panel ${isPreview ? 'preview-mode' : ''}`} style={{ position: 'relative', height: '100%', backgroundColor: '#000' }}>
      {/* Status Overlay */}
      {status !== "Live" && (
        <div style={{ position: 'absolute', top: 10, left: 10, color: 'lime', zIndex: 10, background: 'rgba(0,0,0,0.5)', padding: '2px 5px' }}>
          [{status}]
        </div>
      )}

      {/* The Screen */}
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        autoPlay
        playsInline
        muted
        style={{ objectFit: 'cover' }}
      />
    </div>
  );
}
